import { createFileRoute, redirect } from "@tanstack/react-router"
import { useAuthStore } from "@/store/auth.store"
import { ComplaintDetailsPage as BuyerComplaintDetailsPage } from "@/components/dashboard/buyer/pages/complaints/ComplaintDetailsPage"
import { ComplaintDetailsPage as SellerComplaintDetailsPage } from "@/components/dashboard/seller/pages/complaints/ComplaintDetailsPage"
import { ComplaintDetailsPage as AdminComplaintDetailsPage } from "@/components/dashboard/admin/pages/complaints/ComplaintDetailsPage"

export const Route = createFileRoute("/complaints/$complaintId")({
  beforeLoad: ({ params }) => {
    const { user } = useAuthStore.getState()
    const role = user?.role?.toUpperCase()
    if (role === "BUYER") {
      throw redirect({
        to: "/dashboard/complaints/$complaintId",
        params: { complaintId: params.complaintId },
      })
    }
  },
  component: ComplaintDetailRoute,
})

function ComplaintDetailRoute() {
  const { complaintId } = Route.useParams()
  const role = useAuthStore((s) => s.user?.role)
  if (role === "SELLER") return <SellerComplaintDetailsPage complaintId={complaintId} />
  if (role === "ADMIN") return <AdminComplaintDetailsPage complaintId={complaintId} />
  return <BuyerComplaintDetailsPage complaintId={complaintId} />
}
